import { useHasScope, useHasSomeScopes } from 'crm-activity-creator-data/auth/hooks/useHasScope';
const ENGAGEMENT_WRITE_SCOPE = 'engagements-write';
const TASK_EDIT_SCOPES = ['tasks-edit-team-only', 'tasks-edit-all', 'tasks-edit-owned-only'];

// This logic is copied from crm-records-ui/static/js/crm_ui/tasks/useTaskCreatePermissions.ts
export function useTaskCreatePermissions() {
  const hasEngagementWriteScope = useHasScope(ENGAGEMENT_WRITE_SCOPE);
  const hasSomeTaskEditScopes = useHasSomeScopes(TASK_EDIT_SCOPES);
  if (hasEngagementWriteScope && hasSomeTaskEditScopes) {
    return {
      isDisabled: false
    };
  }
  return {
    isDisabled: true,
    tooltipMessage: 'createActivityButtons.tooltip.taskDisabled'
  };
}